import axios from 'axios';
import clientConfig from '../client-config';
import setAuthToken from '../utils/setAuthToken';

export async function getVideoMenu() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    // Send request

    const res = await axios.get(
      clientConfig.backendHOST + '/video/videoKategoriaMenu',
      '',
      clientConfig.axios_header
    );
    let items = [];

    res.data.map((item) => {
      let mappas = [];
      if (item.video_kategoria_mappas) {
        item.video_kategoria_mappas.map((m) => {
          mappas.push({
            text: m.mappaNev,
            //   icon: 'photo',
            type: 'mappa',
            key: m.kategoriaMappaId,
            path: '/videos',
            vimeoFolder: m.vimeoFolder,

            expanded: true,
          });
        });
      }
      items.push({
        text: item.kategoriaNev,
        //   icon: 'photo',
        type: 'cat',
        key: item.kategoriaId,
        path: '/videos',
        vimeoFolder: item.vimeoFolder,
        items: mappas,
        expanded: true,
      });
    });
    const menu = items;
    /*const menu = [
      {
        text: 'Videók',
        key: 'video_main',
        icon: 'photo',
        path: '/videos',
        items,
      },
    ];*/
    if (res.status === 200) {
      return menu;
    }
    if (res.status === 403) {
      return { error: { status: 403 } };
    }
  } catch (err) {
    return [];
  }
}
